<div class="page-header">
  @if (canUpload$ | async) {
    <button mat-flat-button color="primary" (click)="openUploadModal()">Upload documents</button>
  }
</div>

<div class="container">

  @for (community of communities$ | async; track community) {
    <mat-card (click)="goToCommunity(community)">
      <mat-card-title>{{community.displayName}}</mat-card-title>
      <mat-card-subtitle>{{community.description}}</mat-card-subtitle>
      <mat-card-actions>
        <button mat-flat-button color="primary" (click)="requestAccess($event, community)">Request Access</button>
      </mat-card-actions>
    </mat-card>
  }

</div>


